var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CriterionCreator", {
        attrs: { viewModel: _vm.criterionCreator },
        on: { "create-criterion": _vm.handleCreateCriterionCommand },
      }),
      _vm._v(" "),
      _c("CriterionEditor", {
        attrs: { viewModel: _vm.criterionEditor },
        on: {
          "delete-criterion": _vm.showCriterionDeleter,
          "update-criterion": _vm.handleUpdateCriterionCommand,
        },
      }),
      _vm._v(" "),
      _c("CriterionDeleter", {
        attrs: { viewModel: _vm.criterionDeleter },
        on: { "delete-criterion": _vm.handleDeleteCriterionCommand },
      }),
      _vm._v(" "),
      _c("AttributeLibrary", {
        attrs: { viewModel: _vm.attributeLibrary },
        on: {
          "create-criterion": _vm.handleCreateCriterionFromAttributeCommand,
        },
      }),
      _vm._v(" "),
      _c("CriteriaFromStringBuilder", {
        attrs: { viewModel: _vm.criteriaFromStringBuilder },
        on: { "create-criteria": _vm.handleCreateCriteriaFromStringCommand },
      }),
      _vm._v(" "),
      _c("CriteriaLibrary", {
        attrs: { viewModel: _vm.criteriaLibrary },
        on: {
          "create-criterion": _vm.handleCreateCriterionFromTemplateCommand,
          "show-scale": _vm.showScaleTemplateViewer,
        },
      }),
      _vm._v(" "),
      _c("ScaleTemplateViewer", {
        attrs: { viewModel: _vm.scaleTemplateViewer },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          !_vm.Initialized
            ? _c("h3", [
                _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                _vm._v(" Loading... "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.Initialized
            ? _c(
                "div",
                {
                  on: {
                    dragover: function ($event) {
                      $event.preventDefault()
                      return _vm.onDragOver.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h3", [
                    _vm._v(
                      "\n                Goal: " +
                        _vm._s(_vm.goalName) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("GoalNavigation", {
                    attrs: {
                      WorkspaceId: _vm.workspaceId,
                      ProjectId: _vm.projectId,
                      EvalModelId: _vm.evalModelId,
                      ActivePage: "criteria-hierarchy",
                      ScoringEnabled: _vm.ScoringEnabled,
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    _vm._l(_vm.criteriaView, function (vm) {
                      return _c(
                        "div",
                        {
                          key: vm.CriterionId,
                          style: {
                            marginLeft: vm.Level * 50 + "px",
                            cursor: _vm.isDragEnabled(vm.CriterionId)
                              ? "move"
                              : "default",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "Criterion",
                              attrs: { draggable: "true" },
                              on: {
                                dragstart: function ($event) {
                                  return _vm.onDragStart($event, vm)
                                },
                                dragend: function ($event) {
                                  return _vm.onDragEnd($event, vm)
                                },
                                dragenter: function ($event) {
                                  return _vm.onDragEnter($event, vm)
                                },
                                dragleave: function ($event) {
                                  return _vm.onDragLeave($event, vm)
                                },
                                drop: function ($event) {
                                  return _vm.onDrop($event, vm)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "tile",
                                  class: { CriterionHovered: vm.DragOver },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown",
                                      staticStyle: {
                                        position: "absolute",
                                        right: "40px",
                                      },
                                    },
                                    [
                                      _vm._m(2, true),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-menu dropdown-menu-right",
                                          attrs: { role: "menu" },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showCriterionEditor(
                                                    vm
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Edit")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showCriterionCreator(
                                                    vm
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Add sub-criterion")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showCriteriaFromStringBuilder(
                                                    vm
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Add many")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showAttributeLibrary(
                                                    vm
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Add from attributes")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showCriteriaLibrary(
                                                    vm
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Add from criterion library"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          !_vm.isGoal(vm.CriterionId)
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showCriterionDeleter(
                                                        vm.CriterionId
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Delete")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showCriterionEditor(vm)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "text-ellipsis fg-color-gray",
                                        },
                                        [
                                          _vm.hasSubCriteria(vm.CriterionId)
                                            ? _c("i", {
                                                class: vm.IsCollapsed
                                                  ? "fa fa-folder"
                                                  : "fa fa-folder-open",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    vm.IsCollapsed =
                                                      !vm.IsCollapsed
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [_vm._v(_vm._s(vm.Name))]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "text-ellipsis fg-color-gray1",
                                        },
                                        [_vm._v(_vm._s(vm.Description || " "))]
                                      ),
                                      _vm._v(" "),
                                      _vm.isDragEnabled(vm.CriterionId)
                                        ? _c("div", {
                                            staticClass: "CriterionDragHandler",
                                            attrs: {
                                              title:
                                                "Click and hold to drag criterion",
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-outline-secondary float-right",
        attrs: {
          href: "https://www.transparentchoice.com/user-guide/build-criteria",
          title: "User guide: Build criteria",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "alert alert-info alert-dismissible" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "alert",
            "aria-hidden": "true",
          },
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Use this screen to create your criterion hierarchy. To create a new criterion, simply click on the gear-wheel."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "text-dark", attrs: { "data-toggle": "dropdown" } },
      [_c("i", { staticClass: "fa fa-cog fa-lg" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }